import { DOCUMENT_SIDE } from '../../FileUpload.constants';

export const useDrivingLicenceDocInfoPresenter = ({ pageList }) => {
  const pageListExist = Object.values(DOCUMENT_SIDE).reduce((list, side) => {
    if (
      side === DOCUMENT_SIDE.FRONT &&
      !pageList.some((p) => !p.classification.type || p.classification.type.indexOf(side) > -1)
    ) {
      return [...list, '1'];
    }

    if (
      side === DOCUMENT_SIDE.BACK &&
      !pageList.some((p) => p.classification.type && p.classification.type.indexOf(side) > -1)
    ) {
      return [...list, '2'];
    }

    return list;
  }, []);

  const getColor = (page) => {
    return pageListExist.some((p) => p === page);
  };

  return {
    getColor,
  };
};
